import { autoBookingConfigFragment } from "@saleor/fragments/autoBookingConfig";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  ExpressFleetMallsConfig,
  ExpressFleetMallsConfigVariables
} from "./types/ExpressFleetMallsConfig";

export const expressFleetMallsConfig = gql`
  ${autoBookingConfigFragment}
  query ExpressFleetMallsConfig(
    $first: Int
    $before: String
    $after: String
    $last: Int
    $status: String
    $sortBy: MallSortingInput
    $isServiceable: Boolean
    $id: [ID]
    $search: String
    $hasAutobookingConfig: Boolean
    $hasAutobookingActive: HasAutobookingConfigInput
  ) {
    malls(
      first: $first
      before: $before
      after: $after
      last: $last
      filter: {
        status: $status
        isServiceable: $isServiceable
        id: $id
        search: $search
        hasAutobookingConfig: $hasAutobookingConfig
        hasAutobookingActive: $hasAutobookingActive
      }
      sortBy: $sortBy
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        node {
          id
          name
          hasEnabledAutoBooking
          autoBookingConfig {
            ...AutoBookingConfigFragment
          }
          fbAutoBookingConfig {
            ...AutoBookingConfigFragment
          }
          gmAutoBookingConfig {
            ...AutoBookingConfigFragment
          }
        }
      }
    }
  }
`;
export const useExpressFleetMallsConfig = makeQuery<
  ExpressFleetMallsConfig,
  ExpressFleetMallsConfigVariables
>(expressFleetMallsConfig);
